// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/api";
import { authAPI } from "../api/auth";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [authChecked, setAuthChecked] = useState(false); // New state to ensure it runs once

    useEffect(() => {
        if (authChecked) return; // Prevent running the effect again

        const checkAuth = async () => {
            try {
                const response = await api.post("/auth/refresh-token", {}, {
                    withCredentials: true,
                });
                const token = response.data.accessToken;
                if (token) {
                    // Decode token to check isNewUser flag
                    const decodedToken = jwtDecode(token);
                    setUser({ token, ...decodedToken });
                }
                // setUser(response.data); // Set user if refresh is successful
            } catch (error) {
                console.log("No valid session:", error);
                setUser(null); // Clear user if refresh fails
            } finally {
                setLoading(false);
                setAuthChecked(true); // Mark as checked
            }
        };

        checkAuth();
    }, [authChecked]);

    const login = (token) => {
        setUser({ token });
    };

    const logout = async () => {
        try {
            const response = await authAPI.logout();
            console.log(`response logout`, response);
            if (response?.statusCode === 200) {
                document.cookie = "accessToken=; Max-Age=0; path=/;";
                document.cookie = "refreshToken=; Max-Age=0; path=/;";
                setUser(null);
            }
        } catch (error) {
            console.log("Error in logout :", error);
        } finally {
            setLoading(false);
            setAuthChecked(true); // Mark as checked
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, setUser, login, logout }}>
            {loading ? <div>Loading...</div> : children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};


// // src/context/AuthContext.js
// import React, { createContext, useContext, useState, useEffect } from 'react';
// import api from '../api/api';
// import {jwtDecode} from 'jwt-decode';
//
// const AuthContext = createContext(null);
//
// export const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null);
//     const [loading, setLoading] = useState(true);
//
//     useEffect(() => {
//         const checkAuth = async () => {
//             try {
//                 const response = await api.post('/auth/refresh-token', {}, {
//                     withCredentials: true
//                 });
//                 if (response.data) {
//                     // response.data might include new tokens, user details, etc.
//                     // setUser() with that data or decode the token if needed
//                     setUser(response.data);
//                 }
//             } catch (error) {
//                 // Refresh failed => no valid session. Don't redirect here.
//                 console.log('No valid session:', error);
//                 setUser(null);
//             } finally {
//                 setLoading(false);
//             }
//         };
//
//         checkAuth();
//     }, []);
//
//     const login = (token) => {
//         try {
//             const decoded = jwtDecode(token);
//             // If your server returns new tokens in response to a login,
//             // you might want to set cookies or rely on the server setting them.
//             setUser({ token, ...decoded });
//         } catch (err) {
//             console.error('Error decoding token:', err);
//         }
//     };
//
//     const logout = async () => {
//         // Clear cookies (access & refresh), set user to null
//         document.cookie = 'accessToken=; Max-Age=0; path=/;';
//         document.cookie = 'refreshToken=; Max-Age=0; path=/;';
//         setUser(null);
//         // If you want to navigate user to /login on logout,
//         // you *can* do so here or in your UI logic.
//     };
//
//     return (
//         <AuthContext.Provider value={{ user, loading, login, logout }}>
//             {loading ? <div>Loading...</div> : children}
//         </AuthContext.Provider>
//     );
// };
//
// export const useAuth = () => {
//     const context = useContext(AuthContext);
//     if (!context) {
//         throw new Error('useAuth must be used within an AuthProvider');
//     }
//     return context;
// };
//
//
//
// // src/context/AuthContext.js
// // import React, { createContext, useContext, useState, useEffect } from 'react';
// // import api from "../api/api";
// // import { jwtDecode } from 'jwt-decode';
// //
// // const AuthContext = createContext(null);
// //
// // export const AuthProvider = ({ children }) => {
// //     const [user, setUser] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //
// //     // Check authentication status on mount
// //     useEffect(() => {
// //         const checkAuth = async () => {
// //             try {
// //                 // Try to refresh the token on initial load
// //                 const response = await api.post('/auth/refresh-token', {}, {
// //                     withCredentials: true
// //                 });
// //
// //                 console.log("Refresh token response:", response);
// //
// //                 if (response.data) {
// //                     setUser(response.data);
// //                 }
// //             } catch (error) {
// //                 console.log('No valid session');
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };
// //
// //         checkAuth();
// //     }, []);
// //
// //     const login = async (token) => {
// //         if (token) {
// //             const decodedToken = jwtDecode(token);
// //             setUser({ token, ...decodedToken });
// //         }
// //     };
// //
// //     const logout = async () => {
// //         try {
// //             document.cookie = 'accessToken=; Max-Age=0; path=/;';
// //             document.cookie = 'refreshToken=; Max-Age=0; path=/;';
// //             setUser(null);
// //         } catch (error) {
// //             console.error('Logout error:', error);
// //         }
// //     };
// //
// //     const value = {
// //         user,
// //         setUser,
// //         login,
// //         logout,
// //         loading
// //     };
// //
// //     return (
// //         <AuthContext.Provider value={value}>
// //             {children}
// //         </AuthContext.Provider>
// //     );
// // };
// //
// // export const useAuth = () => {
// //     const context = useContext(AuthContext);
// //     if (!context) {
// //         throw new Error('useAuth must be used within an AuthProvider');
// //     }
// //     return context;
// // };